import React from "react";
import { BrowserView, MobileView } from "react-device-detect";
import { useNavigate } from "react-router-dom";
import NavbarMobileAuth from "../components/organisms/Navbar/NavbarMobileAuth";
import Navbar from "../components/organisms/Navbar/Navbar";

const AuthLayout = ({ web, mob, hideNavbar = false, showCloseButton= true,  showLanguageSelector = false }) => {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate("/landing/home");
  };

  return (
    <div className="auth-layout">
      <BrowserView>
          { !hideNavbar && <Navbar /> }
          {web}
      </BrowserView>
      <MobileView>
          { !hideNavbar && <NavbarMobileAuth cancelClick={handleClose} showLanguageSelector={showLanguageSelector} showCloseButton={showCloseButton} /> }
          {mob}
      </MobileView>
    </div>
  );
};

export default AuthLayout;
